<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items">

    <template #cell(name)="data">
      <m-a class="text-dark text-decoration-none" target="_blank"
           :href="{ name: 'Product', params: { name: data.item.raw_link } }">
        {{ data.item.name }}
      </m-a>
    </template>



    <template #cell(price)="data">
      <update-product-general-info :product="data.item" mode="price"/>
      <update-product-general-info :product="data.item" mode="offer"/>
      <div v-if="data.item.variation == 0">
        <update-product-general-info :product="data.item" mode="quantity"/>
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </template>

    <template #cell(status)="data">
      <status-changer :item="data.item" item-type="product"/>
    </template>

    <template #cell(quantity)="data">

    </template>

    <template #cell(order)="data">

      <update-product-general-info :product="data.item" mode="order"/>
    </template>

    <template #cell(brand)="data">
      <b-badge variant="info" class="text-wrap" v-if="data.item.is_digital==0 && data.item.brand">
        {{ data.item.brand.name }}
      </b-badge>
    </template>

    <template #cell(is_digital)="data">
      <b-badge variant="info" class="text-wrap">
        {{ data.item.is_digital == 0 ? 'فیزیکی' : 'دیجیتال' }}
      </b-badge>
    </template>

    <template #cell(category)="data">
      <span v-for="el in data.item.category">
        <b-badge variant="warning" class="text-wrap d-block mt-2">{{ el.name }}</b-badge>
      </span>
    </template>

    <template #cell(action)="data">
      <div class="" v-if="restoreState === true">
        <span
            @click="forceDeleteProduct(data.item)"
            class="h4 "
            v-b-tooltip.hover
            title="حذف دائمی">
        <b-icon icon="trash" class="m-3"/>
        </span>

        <span
            class="h4 pt-3"
            v-b-tooltip.hover
            title="بازگردانی"
            @click="restore(data.item)"
        >
        <b-icon
            icon="arrow-clockwise"
            class="m-3"

        ></b-icon>
      </span>

      </div>
      <div class="" v-else>

        <span @click="deleteProduct(data.item)" class="h4" v-b-tooltip.hover title="حذف">
            <b-icon icon="trash" class="m-3 h4"/>
        </span>

        <duplicate-item :item="data.item" item-type="product"/>

      </div>
    </template>
  </b-table>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {productThumbnail} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import UpdateProductGeneralInfo from "../../dashboard/product/UpdateProductGeneralInfo";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";

export default {
  name: "tableItems",
  props: ["items", "restoreState"],
  components: {UpdateProductGeneralInfo, StatusChanger, DuplicateItem,},
  data() {
    return {
      tableAttributes: {...tableAttributes, ...{responsive: true}},
      fields: [
        {key: "name", label: "نام"},
        {key: "price", label: ""},
        {key: "action", label: "#"},
      ],
      mainProps: {width: 80, height: 80, class: 'p-0 rounded'}
    };
  },
  methods: {
    productThumbnail,
    formatNumber,
    deleteProduct(item) {
      if (confirm('آیا از حذف این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/deleteProduct", item);
      }
    },
    restore(product) {
      if (confirm('آیا از بازگردانی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/restoreProduct", product);
      }
    },
    forceDeleteProduct(product) {
      if (confirm('آیا از حذف دائمی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/forceDeleteProduct", product);
      }
    },
  },
};
</script>